import { useContext } from 'react';
import StoreContext from '../../react-core-lib/components/app/store-context';
import UserApi from '../../rest-api/user-api';

export function useSendShortFeedback() {
    const { authStore } = useContext(StoreContext);

    const sendShortFeedback = async (feedbackPayload) => {
        try {
            console.warn('Preparing to send short feedback:', feedbackPayload);
            const result = await UserApi.sendShortFeedbackData(authStore.idToken, feedbackPayload);
            return result;
        } catch (error) {
            console.error('Error sending short feedback:', error);
            throw new Error('Failed to send feedback');
        }
    };

    return sendShortFeedback;
}
